<h2
	mat-dialog-title
	class="color-black"
	style="
		display: flex;
		align-items: center;
		justify-content: end;
		border-bottom: none !important;
	"
>
	<div style="align-items: baseline">
		<mat-icon style="color: #9ca3af !important" (click)="onConfirmed(false)"
			>close</mat-icon
		>
	</div>
</h2>
<div class="modal-content">
	<div class="modal-icon" [ngSwitch]="data.type">
		<mat-icon
			*ngSwitchCase="'info'"
			style="font-size: 72px; color: #008db5 !important"
			>info</mat-icon
		>
		<mat-icon
			*ngSwitchCase="'error'"
			style="font-size: 72px; color: #ee4242 !important"
			>error</mat-icon
		>
		<div class="lds-ring" *ngSwitchCase="'processing'">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
		<mat-icon
			*ngSwitchCase="'warning'"
			style="font-size: 72px; color: #f7a40c !important"
			>error</mat-icon
		>
		<mat-icon *ngSwitchDefault color="primary" style="font-size: 72px"
			>check_circle</mat-icon
		>
	</div>
	<h2 *ngIf="data.title" class="modal-title">
		{{ data.title || '¡Operación exitosa!' }}
	</h2>
	<p *ngIf="data.subTitle" class="modal-message">
		{{ data.subTitle || '' }}
	</p>
	<p class="modal-message">
		{{ data.message || 'Información actualizada.' }}
	</p>
  	<div
		*ngIf="htmlContent"
		[innerHTML]="htmlContent"
		class="warning-message"

	></div>
	<div
		class="modal-actions"
		mat-dialog-actions
		style="justify-content: center !important"
	>
		<button
			color="primary"
			(click)="onConfirmed(true)"
			mat-raised-button
			color="primary"
			[disabled]="data.type === 'processing'"
		>
			{{ data.buttonText ? data.buttonText : 'Aceptar' }}
		</button>
		<button
			*ngIf="data.isCancellable && data.isCancellable"
			(click)="onConfirmed(false)"
			color="basic"
			mat-raised-button
		>
			Cancelar
		</button>
	</div>
</div>
